export enum Role {
    admin = 'Admin',
    user = 'User',
}